import { render } from "./MobileBlock.vue?vue&type=template&id=3b89e330&scoped=true"
import script from "./MobileBlock.js?vue&type=script&lang=js"
export * from "./MobileBlock.js?vue&type=script&lang=js"

import "../login/Login.scss?vue&type=style&index=0&id=3b89e330&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b89e330"]])

export default __exports__